import { useCallback } from 'react'
import { FoodGroup } from '../../types/catalog'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Button } from '../../components/ui/Button'

interface Props {
  item: FoodGroup
  onEdit: (item: FoodGroup) => void
  onDelete: (item: FoodGroup) => void
}
export function FoodGroupRow({ item, onEdit, onDelete }: Props) {
  const handleEdit = useCallback(() => onEdit(item), [item, onEdit])
  const handleDelete = useCallback(() => onDelete(item), [item, onDelete])

  return (
    <TR>
      <TD>
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            background: item.color,
            border: '1px solid rgba(0,0,0,0.1)',
          }}
        />
      </TD>
      <TD>
        <code style={{ fontSize: 12, color: '#9b6bb5' }}>{item.code}</code>
      </TD>
      <TD>{item.translations.find(t => t.locale === 'en')?.name ?? '—'}</TD>
      <TD>{item.translations.find(t => t.locale === 'es')?.name ?? '—'}</TD>
      <TD>{item.position}</TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleEdit}>
          Edit
        </Button>
        <Button variant="danger" size="sm" onClick={handleDelete}>
          Delete
        </Button>
      </ActionsCell>
    </TR>
  )
}
